import { trashTodoItem } from '@erikdakoda/todo/ai-tools/trashTodoItem';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(trashTodoItem);
